import { useCallback, useEffect, useState } from "react";
import { Card, Descriptions, Spin, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import CardTitle from "../../core/components/CardTitle";
import AppConfig from "../../core/service/AppConfig";
import ApiService from "../../core/service/api-service";
import ViewerTab from "../../app/viewer-settings/ViewerTab";
import LauncherTab from "../../app/viewer-settings/LauncherTab";
import JdkTab from "../../app/viewer-settings/JdkTab";
import FFmpegTab from "../../app/viewer-settings/FFmpegTab";
import InstallerTab from "../../app/viewer-settings/InstallerTab";

export default function ViewerSettingsPage() {
    const { t } = useTranslation();
    const [settings, setSettings] = useState(null);

    const reload = useCallback(async () => {
        const response = await ApiService.ViewerSettings.GetSettings();
        if (response?.success) {
            setSettings(response.data);
        }
    }, []);

    useEffect(() => {
        document.title = `${t('Viewer Settings')} | ${AppConfig.getRisTitle()}`;
        reload();
    }, [reload, t]);

    return (
        <LayoutWithSider fullWidth={true}>
            <Card title={<CardTitle title={t('Viewer Settings')} />}>
                {!settings ? <Spin /> : (
                    <>
                        <Descriptions size="small" column={3} bordered style={{ marginBottom: 16 }}>
                            <Descriptions.Item label={t('Active viewer')}>
                                {settings.weasis?.version} ({settings.weasis?.versionNumber})
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Active launcher')}>
                                {settings.launcher?.versionNumber}
                            </Descriptions.Item>
                            <Descriptions.Item label={t('Active JDK')}>
                                {settings.launcher?.jdkVersion}
                            </Descriptions.Item>
                        </Descriptions>

                        <Tabs defaultActiveKey="viewer">
                            <Tabs.TabPane tab={t('Viewer')} key="viewer">
                                <ViewerTab settings={settings} reload={reload} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={t('Launcher')} key="launcher">
                                <LauncherTab settings={settings} reload={reload} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={t('JDK')} key="jdk">
                                <JdkTab settings={settings} reload={reload} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={t('FFmpeg')} key="ffmpeg">
                                <FFmpegTab settings={settings} reload={reload} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={t('Installer')} key="installer">
                                <InstallerTab settings={settings} reload={reload} />
                            </Tabs.TabPane>
                        </Tabs>
                    </>
                )}
            </Card>
        </LayoutWithSider>
    );
}
